/* tps-addwith.js · Ticket 1 (6 Oct 2026). "Goes with it" one-tap cards on charcoal pages (snippets/tps-addwith.liquid).
   Tap: /cart/add.js qty 1 -> the THEME drawer renders and opens (no second bag) -> card reads "Added" for 2.2 s.
   Also drives the home "Product of the day" button (sections/tps-potd.liquid, data-addw-src="potd").
   Stamp: dispatches tps:src = data-addw-src, default "attach", after a confirmed add (assets/tps-src.js, a count only).
   Failure (Cicero C5): button "Try again", status "Not added. Try again." One timer per button (AEG-T-07). */
(function (d) {
  function later(b, lbl, txt) {
    clearTimeout(b.__addwT);
    b.__addwT = setTimeout(function () { b.removeAttribute('data-state'); lbl.textContent = txt; }, 2200);
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-addw]');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    var lbl = b.querySelector('[data-addw-lbl]'), sc = b.closest('[data-addw-scope]') || d, st = sc.querySelector('[data-addw-status]'), dr = d.querySelector('cart-drawer');
    if (!lbl.hasAttribute('data-idle')) lbl.setAttribute('data-idle', lbl.textContent);
    var idle = lbl.getAttribute('data-idle');
    var body = { items: [{ id: +b.getAttribute('data-addw'), quantity: 1 }] };
    if (dr && typeof dr.getSectionsToRender === 'function') { body.sections = dr.getSectionsToRender().map(function (s) { return s.id; }).join(','); body.sections_url = location.pathname; }
    clearTimeout(b.__addwT); b.removeAttribute('data-state');
    b.setAttribute('aria-busy', 'true'); lbl.textContent = 'Adding';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (x) {} if (!r.ok || !j) throw 0; return j; }); })
      .then(function (j) {
        b.removeAttribute('aria-busy'); b.setAttribute('data-state', 'added'); lbl.textContent = 'Added';
        if (st) st.textContent = b.getAttribute('data-addw-name') + ' added to cart';
        try { d.dispatchEvent(new CustomEvent('tps:src', { detail: b.getAttribute('data-addw-src') || 'attach' })); } catch (x) {}
        if (dr && typeof dr.renderContents === 'function' && j.sections) dr.renderContents(j);
        else fetch('/?sections=cart-icon-bubble,cart-drawer').then(function (r) { return r.json(); }).then(function (s) { if (dr && dr.renderContents) dr.renderContents({ sections: s }); }).catch(function () {});
        later(b, lbl, idle);
      }, function () {
        b.removeAttribute('aria-busy'); lbl.textContent = 'Try again'; if (st) st.textContent = 'Not added. Try again.';
        later(b, lbl, idle);
      });
  });
})(document);
